import { Navigate } from "react-router-dom"
import { useAuth } from "customerAttachments/auth/AuthProvider"

const AuthRoute = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAuth() || {}

  if (user === null) {
    return <Navigate to="/login" replace />
  }

  return children
}

export default AuthRoute
